import React from 'react'
import { LEG_COMMENTS, QA_COMMENTS } from 'constants/feature-flags'
import AnnotationsContainer from 'redux/containers/pages/comments/AnnotationsContainer'
import useClickEvents from 'hooks/useClickEvents'

const CommentsMainComponent = ({ query, flavour, pageToggleRight }) => {
  const { handleClick } = useClickEvents({ pageToggleRight })
  const {
    category,
    order,
    page = 1,
    users: _users,
    privacy = 'all',
    archived = 'exclude',
    preview = 'hide'
  } = query
  const pageLength = 10
  const selected = category || (QA_COMMENTS && flavour) || (LEG_COMMENTS && 'legislation')
  const users = _users || 'all'

  return (
    <div className='bg-ghost-grey'>
      <AnnotationsContainer
        {...{ selected, category, flavour, order, users, privacy, archived, preview, pageLength, page, handleClick }}
      />
    </div>
  )
}

export default CommentsMainComponent
